import { createRoot } from 'react-dom/client'
import './style/index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <App />
)
